module.exports = __webpack_public_path__ + "img/defaultAvatar.596f0a8c.jpg";